<!-- 全景数据展板 -->
<template>
    <div class="teach-data-board">
      <div class="teach-data-board-left">
          <!-- 集体备课 -->
          <collective-class></collective-class>
          <!-- 特色教研 -->
          <characteristic-teach></characteristic-teach>
          <!-- 名师工作室 -->
          <teach-studio></teach-studio>
      </div>
      <div class="teach-data-board-content">
        <research-dynamics></research-dynamics>
        <!-- 教研访问 -->
        <research-visits></research-visits>
      </div>
      <div class="teach-data-board-right">
          <!-- 听评课 -->
          <listen-lesson></listen-lesson>
          <!-- 论坛研讨 -->
          <forum-discussion></forum-discussion>
          <!-- 活动评审 -->
          <activity-review></activity-review>
      </div>
    </div>
  </template>
  <script>
  import CollectiveClass from "@/views/site/modules/CollectiveClass.vue"
  import CharacteristicTeach from "@/views/site/modules/CharacteristicTeach.vue"
  import TeachStudio from "@/views/site/modules/TeachStudio.vue"
  import ResearchDynamics from "@/views/site/modules/ResearchDynamics.vue"
  import ResearchVisits from "@/views/site/modules/ResearchVisits.vue"
  import ListenLesson from "@/views/site/modules/ListenLesson.vue"
  import ForumDiscussion from "@/views/site/modules/ForumDiscussion.vue"
  import ActivityReview from "@/views/site/modules/ActivityReview.vue"
  export default {
    name: 'teach',
    components:{
        CollectiveClass,
        CharacteristicTeach,
        TeachStudio,
        ResearchDynamics,
        ResearchVisits,
        ListenLesson,
        ForumDiscussion,
        ActivityReview
    },
    data() {
      return {
  
      }
    },
    methods: {
  
    },
    watch: {
  
    },
    computed: {
  
    },
    mounted() {
    },
  }
  </script>
  <style lang="scss" scoped>
 @font-face {
    font-family: DigifaceWide;
    src: url('../../../assets/fonts/DigifaceWide Regular.ttf'); //字体路径
}
.teach-data-board{
  display: flex;
  // align-items: center;
  justify-content: space-between;
  width: 100%;
  .teach-data-board-left{
    width: calc(25% - 10px);
  }
  .teach-data-board-content{
    width: calc(50% - 20px);
  }
  .teach-data-board-right{
    width: calc(25% - 10px);
  }
}
  </style>